import { Box, styled } from "@mui/material";

export const ActivitiesRenderItemWrapper = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  height: "auto",
})) as typeof Box;

export const ActivitiesRenderItemHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "10px",

  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
  },
})) as typeof Box;

export const ActivitiesRenderItemBody = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",

  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
  },
})) as typeof Box;
